/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { createGlobalStyle } from 'styled-components';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import VictoryScatterComponent from '../component/VictoryScatterComponent';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import { ActiveSurfaceApi } from '../../utils/api';
import { getParamsEnvironment } from '../../utils/helpers/apiHelper';
import Loader from '../../components/common/Loader';
import { getFirstAndLastDayOfYear, linearRegressionThroughOrigin } from '../../utils/helpers/module/ecpHelper';

type chartProps = {
  showTab: boolean;
  collectionPoolId: number;
};

function ActiveSurfaceChart({ showTab, collectionPoolId }: chartProps) {
  const colorsLegend = ['#008BD2', '#fff', '#fff'];
  const yearMinusOne = new Date().getFullYear() - 1;
  const yearMinusTwo = new Date().getFullYear() - 2;
  const yearMinusThree = new Date().getFullYear() - 3;
  const yearMinusFour = new Date().getFullYear() - 4;
  const yearMinusFive = new Date().getFullYear() - 5;
  const years = [
    yearMinusFive,
    yearMinusFour,
    yearMinusThree,
    yearMinusTwo,
    yearMinusOne,
  ];
  const [error, setError] = useState(false);
  const [activeSurfaceData, setActiveSurfaceData] = useState<any>(null);
  const [slope, setSlope] = useState<number>();
  const [scoreR2, setScoreR2] = useState<number>();
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState<number>(years[4]);

  useEffect(() => {
    // condition used to calculate Linear Regression 
    if (activeSurfaceData?.points.length > 0) {
      const xValues = activeSurfaceData?.points.map((point) => point.x);
      const yValues = activeSurfaceData?.points.map((point) => point.y);
      const regression = linearRegressionThroughOrigin(xValues, yValues);
      setSlope(regression.slope!);
      setScoreR2(regression.r2!);
    }
  }, [activeSurfaceData]);

  useEffect(() => {
    // get data for
    // call to api
    try {
      const { firstDay, lastDay } = getFirstAndLastDayOfYear(selectedYear);
      const promise = ActiveSurfaceApi.getSurfaceParameters(
        collectionPoolId,
        firstDay,
        lastDay,
      );
      setError(false);
      getParamsEnvironment(promise, setActiveSurfaceData, setLoading, setError);
    } catch (error) {
      setError(true);
      console.log(error);
    }
  }, [selectedYear]);

  return (
    <Container className='active-surface-container'>
      <Styles />
      {loading ? (
        <>
          <Loader IsVisible={true} />
        </>
      ) : null}
      <Card automatedTestId={'active-surface'}>
        <Word
          className='active-surface-title'
          variant='h3'
          textStyle='titleSmall'
          value='Relation entre cumul de pluie et survolume affectant le réseau gravitaire du poste'
        />
        <Container className='years-list'>
          {years.map((year) => (
            <Button
              key={year}
              className={selectedYear === year ? 'active' : 'year-item'}
              mode='basic'
              onClick={() => setSelectedYear(year)}
            >
              <Word
                variant='span'
                textStyle='normalBold'
                value={year.toString()}
              />
            </Button>
          ))}
        </Container>
        {loading === false && showTab === true && !error &&
          activeSurfaceData?.points.length > 0 ? (
            <Container className='chart-container'>
              <VictoryScatterComponent
                height={300}
                width={600}
                data={activeSurfaceData.points}
                legend={activeSurfaceData.points && slope !== undefined && scoreR2 !== undefined ? [
                  `Surface active : ${slope !== null && !isNaN(slope) ? `${parseFloat(slope.toFixed(4))/10} ha` : 'NA'}`,
                  `y = ${slope !== null && !isNaN(slope) ? parseFloat(slope.toFixed(4)) : 'NA'} x`,
                  `R2 = ${scoreR2 !== null && !isNaN(scoreR2) ? parseFloat(scoreR2.toFixed(4)) : 'NA'}`,
                ] : [
                  'Surface active : Calcul en cours...',
                  'y = Calcul en cours...',
                  'R2 = Calcul en cours...',
                ]}
                lineData={{
                  slope: slope && !isNaN(slope) ? slope : 0,
                }}
                colorsLegend={colorsLegend}
              />
            </Container>
          ) : (
            <Container
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '90px 0',
              }}
            >
              <Word value='Aucune données !' variant='h2' />
            </Container>
          )}
      </Card>
    </Container>
  );
}

const Styles = createGlobalStyle`
.sds-reset-style{
    .active-surface-container{
        .active-surface-title{
            text-align: center;
            margin: 20px 0;
        }
        .years-list{
            display: flex;
            flex-direction: row;
            justify-content: center;
            .year-item, .active {
                margin: 0 15px;
                height: 40px;
                width: auto;
                border-radius: 10px;
                font-weight: bold;
                padding: 10px;
            }
            .year-item{
                background-color: #ECF1F8;
            }
              .active {
                background-color: #008BD2;
                span{
                   color: #FFFFFF; 
                }
    }
        }
        .chart-container{
            flex-direction: row;
            .VictoryContainer{
            height: 560px !important;
        }
        .ecp-legend-word{
            font-size: 18px !important;
        }
        }
    }
}`;

export default React.memo(ActiveSurfaceChart);
